import {combineReducers, Reducer} from "redux";
import {kAlertReducer, kptableReducer} from "@kopjra/uikit";
import {i18nReducer, I18nState} from "react-redux-i18n";
import {usersReducer} from "./users";
import {htmlSignaturesReducer} from "./htmlSignatures";
import {dataSignaturesReducer} from "./dataSignatures";
import {pdfSignaturesReducer} from "./pdfSignatures";
import {timestampsReducer} from "./timestamps";
import {aesSignaturesReducer} from "./aesSignatures";

export const rootReducer = combineReducers({
    i18n: i18nReducer as unknown as Reducer<I18nState>,
    alert: kAlertReducer,
    kptable: kptableReducer,
    user: usersReducer,
    html: htmlSignaturesReducer,
    data: dataSignaturesReducer,
    pdf: pdfSignaturesReducer,
    aes: aesSignaturesReducer,
    timestamp: timestampsReducer,
});